import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const shipedgeSettings = defineIntegrationSettings({
  fields: {
    enabled: z.boolean(),
    accountId: z.string().trim().min(1, "Account ID is required"),
    integrationHost: z.string().trim().min(1, "Integration host is required"),
    warehouse: z.string().trim().min(1, "Warehouse is required"),
  },
  secrets: { apiKey: z.string().trim().min(1, "API key is required") },
  connectOnly: {},
  computed: {},
});
